import fileFunction from '@/api/file-manager/file-function'

export const defaultState = {}

export const actions = {
  createFolder(context, data) {
    return fileFunction.createFolder(data)
  },
  deleteItem(context, data) {
    return fileFunction.deleteItem(data)
  }
}

export const mutations = {
}

export const getters = {}
